import { AlertDialog, Button, Flex } from '@radix-ui/themes'

type DiscardChangesDialogProps = {
  open: boolean
  onDiscard: () => void
  onCancel: () => void
}

export const DiscardChangesDialog = ({ open, onDiscard, onCancel }: DiscardChangesDialogProps) => {
  return (
    <AlertDialog.Root open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialog.Content>
        <AlertDialog.Title>Are you sure you want to exit?</AlertDialog.Title>
        <AlertDialog.Description>This information will not be saved.</AlertDialog.Description>
        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button variant="outline" onClick={onCancel}>
              Cancel
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button color="red" onClick={onDiscard}>
              Discard
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  )
}
